module.exports = __webpack_public_path__ + "img/yuyin.a4d5f0f0.png";